module.exports = "<div class=\"container d-flex flex-column\">\n  <h3>{{labels.fuelcount}}</h3>\n  <p>{{labels.last7Days}}</p>\n  <div #chart id=\"chart\" class=\"d3-chart\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/chart/bars/bars.component.html
// module id = ./src/app/chart/bars/bars.component.html
// module chunks = main